import React, { Fragment, useCallback } from "react";
import { injectIntl, defineMessages } from "react-intl";
import compose from "recompose/compose";
import Button from "theme/components/atoms/Button";
import Icon from "theme/components/atoms/Icon";
import EnhanceAddWishlistProductToCart from "./EnhanceAddWishlistProductToCart";
import useAddToCartModal from "theme/modules/AddToCart/AddToCartModal/useAddToCartModal";
import useConditionalCallOnMount from "theme/components/helpers/useConditionalCallOnMount";

const messages = defineMessages({
  addToCart: {
    id: "modules.Wishlist.AddWishlistProductToCart.addToCart",
    defaultMessage: "Move to cart",
  },
});

const AddWishlistProductToCart = (props) => {
  const [addToCart, , addToCartModal] = useAddToCartModal({
    product: props.wishlistItem.product,
    selectedOptions: props.wishlistItem.selectedOptions,
    selectedBundleOptions: props.wishlistItem.selectedBundleOptions,
    selectedCustomOptions: props.wishlistItem.selectedCustomOptions,
    onSuccess: () => {
      props.toggleProductInWishlistWhenAddedToCart &&
        props.toggleProductInWishlist();
    },
  });

  const onAddStart = props.onAddStart;
  const openAddToCartModal = useCallback(() => {
    typeof onAddStart === "function" && onAddStart();
    addToCart();
  }, [onAddStart, addToCart]);

  useConditionalCallOnMount(props.addToCartOpenedDefault, openAddToCartModal);

  return (
    <Fragment>
      <div>
        <Button
          state={props.commandPending ? "pending" : null}
          size="small"
          onClick={openAddToCartModal}
        >
          <Icon
            title={props.intl.formatMessage(messages.addToCart)}
            icon={"cart"}
          />
        </Button>
      </div>
      {addToCartModal}
    </Fragment>
  );
};

export default compose(
  EnhanceAddWishlistProductToCart(),
  injectIntl
)(AddWishlistProductToCart);
